import React, { useState } from 'react';
import { useListContext, useTranslate } from 'react-admin';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';

const StyledCustomSortButton = styled(Box)({
    ...analyticsStyles.periodInput,
});

export const CustomSortButton = ({ label, options = [] }) => {
    const { sort, setSort } = useListContext();
    const [open, setOpen] = useState(false);
    const translate = useTranslate();

    const buttonLabel = label || translate('common.sort');

    const sortOptions = options.map(opt => ({
        value: `${opt.field}:${opt.order}`,
        label: opt.label ?? opt.field,
        field: opt.field,
        order: opt.order || 'ASC',
    }));

    const labelByValue = sortOptions.reduce((acc, opt) => {
        acc[opt.value] = opt.label;
        return acc;
    }, {});

    const currentValue = sort ? `${sort.field}:${sort.order}` : '';

    const handleChange = event => {
        const selected = event.target.value;
        if (!selected) {
            setSort({ field: '', order: 'ASC' });
            return;
        }

        const [field, order] = selected.split(':');
        setSort({ field, order: order === 'DESC' ? 'DESC' : 'ASC' });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <StyledCustomSortButton className='period-form'>
            <FormControl className='period-select'>
                <InputLabel id='custom-sort-label'>{buttonLabel}</InputLabel>
                <Select
                    labelId='custom-sort-label'
                    value={currentValue}
                    onChange={handleChange}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={open}
                    label={buttonLabel}
                    renderValue={selected => labelByValue[selected] || selected}
                >
                    {sortOptions.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </StyledCustomSortButton>
    );
};
